"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _mixins = require("../../styles/mixins");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBRadioButton = require("./HBRadioButton.styles");
var _templateObject;
// Due to a problem with Radio visibility, this is a solution for pdf printing.

var MockPrintRadioButton = function MockPrintRadioButton(_ref) {
  var size = _ref.size,
    color = _ref.color,
    checked = _ref.checked;
  return /*#__PURE__*/_react["default"].createElement(OuterCircle, {
    size: size,
    color: color,
    checked: checked
  }, /*#__PURE__*/_react["default"].createElement(InnerCircle, {
    size: size,
    checked: checked
  }));
};
var _default = exports["default"] = MockPrintRadioButton; // -------------------------------- Styles -------------------------------- //
var OuterCircle = _styledComponents["default"].div.withConfig({
  displayName: "MockPrintRadioButton__OuterCircle",
  componentId: "sc-xsu3ab-0"
})(["align-self:center;", " ", " width:", ";height:", ";border-radius:50%;border:1px solid;border-color:", ";", ";"], _mixins.flexCenterAll, (0, _mixins.showInPrintOnly)('flex'), function (props) {
  return _HBRadioButton.RADIO_BUTTON_STYLES[props.size].outerCircle;
}, function (props) {
  return _HBRadioButton.RADIO_BUTTON_STYLES[props.size].outerCircle;
}, _colors["default"].neutral600, (0, _styledIs["default"])('checked')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        background: ", ";\n        border-color: ", "\n    "])), function (props) {
  return props.color || _colors["default"].neutral900;
}, function (props) {
  return props.color || _colors["default"].neutral900;
}));
var InnerCircle = _styledComponents["default"].div.withConfig({
  displayName: "MockPrintRadioButton__InnerCircle",
  componentId: "sc-xsu3ab-1"
})(["width:", ";height:", ";border-radius:50%;background:", ";opacity:", ";"], function (props) {
  return _HBRadioButton.RADIO_BUTTON_STYLES[props.size].innerCircle;
}, function (props) {
  return _HBRadioButton.RADIO_BUTTON_STYLES[props.size].innerCircle;
}, _colors["default"].white, function (props) {
  return props.checked ? 1 : 0;
});
//# sourceMappingURL=MockPrintRadioButton.js.map